import * as swcHelpers from '@swc/helpers';

const getFramesDisplayPrice = (variantPrice, offering)=>{
    var ref;
    const updatedPrice = {
        originalPrice: variantPrice.originalPrice,
        discountedPrice: variantPrice === null || variantPrice === void 0 ? void 0 : variantPrice.discountedPrice,
        currency: variantPrice.currency,
        isCentAmount: variantPrice.isCentAmount
    };
    if (offering === null || offering === void 0 ? void 0 : (ref = offering.originalPriceInformation) === null || ref === void 0 ? void 0 : ref.amount) {
        var ref1;
        const offeringOriginalPrice = offering.originalPriceInformation.amount;
        const offeringDiscountPrice = (ref1 = offering.discountedPriceInformation) === null || ref1 === void 0 ? void 0 : ref1.amount;
        if (offeringDiscountPrice) {
            if (updatedPrice.discountedPrice) {
                // -- Variant AND Offering with discount --
                updatedPrice.discountedPrice += offeringDiscountPrice;
            } else {
                //-- Only Offering with discount --
                updatedPrice.discountedPrice = updatedPrice.originalPrice + offeringDiscountPrice;
            }
        } else if (updatedPrice.discountedPrice) {
            //-- Only Variant with discount --
            updatedPrice.discountedPrice += offeringOriginalPrice;
        }
        updatedPrice.originalPrice += offeringOriginalPrice;
    }
    return swcHelpers.objectSpread({}, variantPrice, updatedPrice);
};

export { getFramesDisplayPrice };
//# sourceMappingURL=get-frames-display-price.js.map
